import type {PullRequestActiveRoute} from '../hooks/use-active-route'

export interface PullRequestRouteConfig {
  /** Whether the layout should use full-width (files/changes/checks) or condensed (conversation/overview/commits). */
  layout: 'full-width' | 'condensed'
  /** Whether the docked side panel is supported on this route. */
  dockedPanelSupported: boolean
}

const routeConfigs: Record<PullRequestActiveRoute, PullRequestRouteConfig> = {
  overview: {
    layout: 'condensed',
    dockedPanelSupported: false,
  },
  conversation: {
    layout: 'condensed',
    dockedPanelSupported: false,
  },
  files_changed: {
    layout: 'full-width',
    dockedPanelSupported: true,
  },
  commits: {
    layout: 'condensed',
    dockedPanelSupported: false,
  },
  checks: {
    layout: 'full-width',
    dockedPanelSupported: false,
  },
  findings: {
    layout: 'condensed',
    dockedPanelSupported: false,
  },
  walkthrough: {
    layout: 'full-width',
    dockedPanelSupported: false,
  },
}

export function getRouteConfig(activeRoute: PullRequestActiveRoute): PullRequestRouteConfig {
  return routeConfigs[activeRoute]
}
